import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button, Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../global-config'
import { StaticImage } from '../../../../../image'
import { urlResolverNfcLandingPage } from '../../../../../url-handling'

import ImgNfcVisual from './nfcVisual.png'

const accentuateTextItalicHighlight = (text: ReactNode[]): ReactElement => (
  <span className="font-medium italic text-dark-brand">{text}</span>
)

const lineBreak = (): ReactElement => <br />

export const RxLpComNfcIsAvailableBanner: FC = () => {
  const intl = useIntl()
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="container pt-9 tablet:pb-4 tablet:pt-12">
      <Link
        className="flex min-h-36 flex-row gap-4 rounded-2xl bg-light-secondary-medium px-4 pt-4 text-inherit no-underline hover:text-inherit tablet:mx-auto tablet:min-h-44 tablet:gap-6 tablet:px-6 tablet:py-0"
        href={urlResolverNfcLandingPage(globalConfig)}
      >
        <div className="relative flex w-32 tablet:w-64 tablet:px-4 tablet:pt-3">
          <StaticImage
            alt={intl.formatMessage({ id: 'deErx.nfcIsAvailable.imgAlt' })}
            className="w-[100px] self-end object-contain tablet:ml-auto tablet:w-[131px]"
            src={ImgNfcVisual}
          />
          <div className="absolute right-2 top-4 flex size-10 items-center justify-center rounded-full bg-light-tertiary text-xs font-medium uppercase leading-[1.25] tablet:right-auto tablet:top-1/2 tablet:size-[120px] tablet:-translate-y-1/2 tablet:text-3xl">
            <FormattedMessage id="rxSelectModal.nfc.badge" />
          </div>
        </div>

        <div className="flex flex-1 flex-col gap-4 pb-4 tablet:flex-row tablet:items-center tablet:gap-6 tablet:py-4">
          <div className="flex flex-1 flex-col gap-3">
            <span className="text-m font-medium tablet:text-left tablet:text-2xl">
              <FormattedMessage
                id="rxSelectModal.nfc.title"
                values={{
                  accentuate: accentuateTextItalicHighlight,
                  break: lineBreak,
                }}
              />
            </span>
            <span className="hidden tablet:block">
              <FormattedMessage id="rxSelectModal.nfc.info" />
            </span>
          </div>
          <Button<'button'>
            className="min-h-9 w-full text-xs tablet:mt-0 tablet:size-fit tablet:min-h-12 tablet:text-s"
            size="medium"
            variant="outlined"
          >
            <FormattedMessage id="rxSelectModal.nfc.button.new" />
          </Button>
        </div>
      </Link>
    </div>
  )
}
